import { ACCOUNT_STATUS, AdminUser } from "@shared/lib/types";
import styles from "./styles.module.scss";
import { Space, Image, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";

interface Props {
  employee: AdminUser;
  handleEditClick: () => void;
}

export function EmployeeCard({ employee, handleEditClick }: Props) {
  return (
    <div className={styles.card}>
      <Space
        style={{
          justifyContent: "space-between",
          width: "100%",
          alignItems: "start",
        }}>
        <Image src={employee.profilePicUrl} className={styles.image} />
        <Tag
          color={
            employee.accountStatus === ACCOUNT_STATUS.ACTIVE ? "green" : "red"
          }>
          {employee.accountStatus}
        </Tag>
      </Space>
      <div className={styles.name}>
        {employee.firstName} {employee.lastName}
      </div>
      <div className={styles.role}>{employee.role}</div>
      <div className={styles.email}>
        Email: <u>{employee.emailId}</u>
      </div>
      <Space style={{ justifyContent: "space-between", width: "100%" }}>
        <div className={styles.phone}>
          Phone: {employee.countryCode}-{employee.phoneNumber}
        </div>
        <EditOutlined className={styles.icon} onClick={handleEditClick} />
      </Space>
    </div>
  );
}
